<template>
  <div class="qdc-wrap">
    <canvas ref="canvas" class="qdc-canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { markRaw } from "vue";

export default {
  name: "QuantyDonutChart",
  props: {
    labels:  { type: Array, default: () => [] },
    values:  { type: Array, default: () => [] },
    colors:  { type: Array, default: () => [] },
    size:    { type: Number, default: 200 },
  },
  data() {
    return { chart: null };
  },
  mounted() {
    this.$nextTick(() => this.initChart());
  },
  beforeUnmount() {
    if (this.chart) { this.chart.destroy(); this.chart = null; }
  },
  watch: {
    values(newVal) {
      if (!this.chart) return;
      this.chart.data.datasets[0].data = [...newVal];
      this.chart.update();
    },
  },
  methods: {
    initChart() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      if (this.chart) { this.chart.destroy(); this.chart = null; }

      this.chart = markRaw(new Chart(canvas, {
        type: "doughnut",
        data: {
          labels: [...this.labels],
          datasets: [{
            data: [...this.values],
            backgroundColor: this.colors,
            borderWidth: 3,
            borderColor: "#fff",
            hoverOffset: 6,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          cutout: "68%",
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: "rgba(11,42,74,0.92)",
              titleFont: { size: 12, family: "Nunito Sans" },
              bodyFont:  { size: 12, family: "Nunito Sans" },
              padding: 10,
              callbacks: {
                label: (ctx) => `  ${ctx.label}: ${ctx.raw} (${ctx.parsed === ctx.raw ? '' : ''}${((ctx.raw / ctx.dataset.data.reduce((a,b)=>a+b,0))*100).toFixed(1)}%)`,
              },
            },
          },
        },
      }));
    },
  },
};
</script>

<style scoped>
.qdc-wrap   { position: relative; width: 100%; max-width: 200px; margin: 0 auto; }
.qdc-canvas { width: 100% !important; }
</style>
